import DesignUnderLine from "../../components/ExcerciseTypes/Design/DesignUnderLine";
import UI from "../../components/ExcerciseTypes/Design/UserInterface";
import Circle_Write from '../../components/ExcerciseTypes/Circle_Write';

const json = {
  4: {
    // Exercise num
    unit: "Unit 12",
    id: "SB3-u12-P87-E1",
    audio: "",
    video: "",
    component: DesignUnderLine,
    totalInput: 5,
    hideBtnFooter: true,
    exerciseKey: "img/FriendsPlus/Page87/E1/Key/answerKey.png",
    questionImage: [
      [
        // Column1
        { url: 'img/FriendsPlus/Page87/E1/1.jpg' },
      ],
      [
        // Column2
        { url: 'img/FriendsPlus/Page87/E1/2.jpg' },
        { url: 'img/FriendsPlus/Page87/E1/3.jpg', input: 1, isCorrect: true },
        { url: 'img/FriendsPlus/Page87/E1/4.jpg' },
        { url: 'img/FriendsPlus/Page87/E1/5.jpg', input: 1 },
        { url: 'img/FriendsPlus/Page87/E1/6.jpg' },
        { url: 'img/FriendsPlus/Page87/E1/7.jpg', input: 1 },
        { url: 'img/FriendsPlus/Page87/E1/8.jpg' },
      ],
      [
        // Column3
        { url: 'img/FriendsPlus/Page87/E1/9.jpg' },
      ],
      [
        // Column4
        { url: 'img/FriendsPlus/Page87/E1/10.jpg' },
        { url: 'img/FriendsPlus/Page87/E1/11.jpg', input: 2 },
        { url: 'img/FriendsPlus/Page87/E1/12.jpg' },
        { url: 'img/FriendsPlus/Page87/E1/13.jpg', input: 2, isCorrect: true },
        { url: 'img/FriendsPlus/Page87/E1/14.jpg' },
        { url: 'img/FriendsPlus/Page87/E1/15.jpg', input: 2 },
        { url: 'img/FriendsPlus/Page87/E1/16.jpg' },
        { url: 'img/FriendsPlus/Page87/E1/17.jpg', input: 3, isCorrect: true },
        { url: 'img/FriendsPlus/Page87/E1/18.jpg' },
        { url: 'img/FriendsPlus/Page87/E1/19.jpg', input: 3 },
        { url: 'img/FriendsPlus/Page87/E1/20.jpg' },
        { url: 'img/FriendsPlus/Page87/E1/21.jpg', input: 3 },
        { url: 'img/FriendsPlus/Page87/E1/22.jpg' },
      ],
      [
        // Column5
        { url: 'img/FriendsPlus/Page87/E1/23.jpg' },
      ],
      [
        // Column6
        { url: 'img/FriendsPlus/Page87/E1/24.jpg' },
        { url: 'img/FriendsPlus/Page87/E1/25.jpg', input: 4 },
        { url: 'img/FriendsPlus/Page87/E1/26.jpg' },
        { url: 'img/FriendsPlus/Page87/E1/27.jpg', input: 4 },
        { url: 'img/FriendsPlus/Page87/E1/28.jpg' },
        { url: 'img/FriendsPlus/Page87/E1/29.jpg', input: 4, isCorrect: true },
        { url: 'img/FriendsPlus/Page87/E1/30.jpg' },
        { url: 'img/FriendsPlus/Page87/E1/31.jpg', input: 5, isCorrect: true },
        { url: 'img/FriendsPlus/Page87/E1/32.jpg' },
        { url: 'img/FriendsPlus/Page87/E1/33.jpg', input: 5 },
        { url: 'img/FriendsPlus/Page87/E1/34.jpg' },
        { url: 'img/FriendsPlus/Page87/E1/35.jpg', input: 5 },
        { url: 'img/FriendsPlus/Page87/E1/36.jpg' },
      ],
      [
        // Column7
        { url: 'img/FriendsPlus/Page87/E1/37.jpg' },
      ],
    ]
  },
  5: { // Exercise num
    unit: 'Unit 12',
    id: 'SB3-U12-P87-E2',
    audio: '',
    video: '',
    component: Circle_Write,
    exerciseKey: 'img/FriendsPlus/Page87/E2/Key/answerKey.png',
    titleQuestion: [{ num: '5', title: 'Read and circle the correct word.', color: "#1F4199" }],
    question: {
      Write: {
        // checkUppercase: true,
        inputStyle: {},
        answers: [],
        initialValue: [],
      },
      Circle: {
        initialWordStyle: { fontWeight: 'bold' },
        selectWordStyle: { border: 'solid 2px', borderColor: '#00a8ec', borderRadius: '50%', padding: 3 },
        limitSelect: 1,
        listWords: [
          'wasn’t / weren’t', //0
          'was / were', //1
          'was / were', //2
          'wasn’t / weren’t', //3
          'was / were', //2
        ],
        answers: ['0-4', '1-4', '2-4', '3-0', '4-4'],
        initialValue: [],
      },
      Layout: `
        <div style='display: flex; flex-direction: row;position: relative;background-color: rgb(232,247,253); padding: 20px;'>
          <div style='flex: 1'>
            <img src="img/FriendsPlus/Page87/E2/1.jpg" style="width: 100%">
          </div>
          <div style='flex: 2;margin-left: 10px;'>
            <div><b>1</b>&nbsp;On Wednesday, it <span style='font-weight: bold;'><span style="border: 2px solid rgb(0, 168, 236);padding: 3px;border-radius: 50%;">was</span> / were</span> our school play.</div>
            <div><b>2</b>&nbsp;The children <input id='0' type='Circle' /> in the classroom.</div>
            <div><b>3</b>&nbsp;They <input id='1' type='Circle' /> in the school yard.</div>
            <div><b>4</b>&nbsp;Our moms and dads <input id='2' type='Circle' /> there, too.</div>
            <div><b>5</b>&nbsp;Our teacher <input id='3' type='Circle' /> sad.</div>
            <div><b>6</b>&nbsp;All the children <input id='4' type='Circle' /> very happy!</div>
          </div>
        </div>
      `,
    },
  },
  6: {
    // Exercise num
    unit: "Unit 12",
    id: "SB3-u12-P87-E3",
    audio: "",
    video: "",
    component: UI,
    question: [],
    questionImage: [[{ url: "img/FriendsPlus/Page87/E3/1.jpg" }]],
  },
};

export default json;
